import type { DashboardStats, PeakStats, TopItemStat, TrendPoint } from '@container-system/shared';
import { apiRequest } from './client';

export const statsApi = {
  dashboard: () => apiRequest<DashboardStats>('/api/stats/dashboard'),
  peak: () => apiRequest<PeakStats>('/api/stats/peak'),
  trend: (days = 365) => apiRequest<TrendPoint[]>(`/api/stats/trend?days=${days}`),
  topContainers: (limit = 5) => apiRequest<TopItemStat[]>(`/api/stats/top/containers?limit=${limit}`),
  topMaterials: (limit = 5) => apiRequest<TopItemStat[]>(`/api/stats/top/materials?limit=${limit}`),
  topAlloys: (limit = 5) => apiRequest<TopItemStat[]>(`/api/stats/top/alloys?limit=${limit}`),
};
